<template>
  <div class="details_form_item">
    <Form :model="dataModel" :label-width="130">
      <FormItem label="客户端SN码：">{{dataModel.clientSN}}</FormItem>
      <FormItem label="类型：">{{$common.getEnumDescription("clientLogType", dataModel.clientLogType)}}</FormItem>
      <FormItem label="错误码：">{{dataModel.clientLogCode}}</FormItem>
    
      <FormItem label="标题：">{{dataModel.clientLogTitle}}</FormItem>
      <FormItem label="详情：">{{dataModel.clientLogDescription}}</FormItem>
      <FormItem label="创建时间：">{{dataModel.clientLogDate}}</FormItem>
      <FormItem label="是否查看：">{{dataModel.isRead=="0"?"否":"是"}}</FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  components: {},
  data: function () {
    return {
      dataModel: {},
    };
  },

  created: function () {
    this.dataModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>